export default [
  {
    login: "abdabdii",
    id: 67204878,
    node_id: "MDQ6VXNlcjY3MjA0ODc4",
    avatar_url: "https://avatars.githubusercontent.com/u/67204878?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/abdabdii",
    html_url: "https://github.com/abdabdii",
    followers_url: "https://api.github.com/users/abdabdii/followers",
    following_url:
      "https://api.github.com/users/abdabdii/following{/other_user}",
    gists_url: "https://api.github.com/users/abdabdii/gists{/gist_id}",
    starred_url: "https://api.github.com/users/abdabdii/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/abdabdii/subscriptions",
    organizations_url: "https://api.github.com/users/abdabdii/orgs",
    repos_url: "https://api.github.com/users/abdabdii/repos",
    events_url: "https://api.github.com/users/abdabdii/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/abdabdii/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "Hesham-Hamdan",
    id: 112446931,
    node_id: "U_kgDOBrPN0w",
    avatar_url: "https://avatars.githubusercontent.com/u/112446931?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/Hesham-Hamdan",
    html_url: "https://github.com/Hesham-Hamdan",
    followers_url: "https://api.github.com/users/Hesham-Hamdan/followers",
    following_url:
      "https://api.github.com/users/Hesham-Hamdan/following{/other_user}",
    gists_url: "https://api.github.com/users/Hesham-Hamdan/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/Hesham-Hamdan/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/Hesham-Hamdan/subscriptions",
    organizations_url: "https://api.github.com/users/Hesham-Hamdan/orgs",
    repos_url: "https://api.github.com/users/Hesham-Hamdan/repos",
    events_url: "https://api.github.com/users/Hesham-Hamdan/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/Hesham-Hamdan/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "ThaELL1",
    id: 37319124,
    node_id: "MDQ6VXNlcjM3MzE5MTI0",
    avatar_url: "https://avatars3.githubusercontent.com/u/37319124?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/ThaELL1",
    html_url: "https://github.com/ThaELL1",
    followers_url: "https://api.github.com/users/ThaELL1/followers",
    following_url:
      "https://api.github.com/users/ThaELL1/following{/other_user}",
    gists_url: "https://api.github.com/users/ThaELL1/gists{/gist_id}",
    starred_url: "https://api.github.com/users/ThaELL1/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/ThaELL1/subscriptions",
    organizations_url: "https://api.github.com/users/ThaELL1/orgs",
    repos_url: "https://api.github.com/users/ThaELL1/repos",
    events_url: "https://api.github.com/users/ThaELL1/events{/privacy}",
    received_events_url: "https://api.github.com/users/ThaELL1/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "degreeck",
    id: 31404082,
    node_id: "MDQ6VXNlcjMxNDA0MDgy",
    avatar_url: "https://avatars1.githubusercontent.com/u/31404082?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/degreeck",
    html_url: "https://github.com/degreeck",
    followers_url: "https://api.github.com/users/degreeck/followers",
    following_url:
      "https://api.github.com/users/degreeck/following{/other_user}",
    gists_url: "https://api.github.com/users/degreeck/gists{/gist_id}",
    starred_url: "https://api.github.com/users/degreeck/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/degreeck/subscriptions",
    organizations_url: "https://api.github.com/users/degreeck/orgs",
    repos_url: "https://api.github.com/users/degreeck/repos",
    events_url: "https://api.github.com/users/degreeck/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/degreeck/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "Kemmy91",
    id: 42711367,
    node_id: "MDQ6VXNlcjQyNzExMzY3",
    avatar_url: "https://avatars2.githubusercontent.com/u/42711367?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/Kemmy91",
    html_url: "https://github.com/Kemmy91",
    followers_url: "https://api.github.com/users/Kemmy91/followers",
    following_url:
      "https://api.github.com/users/Kemmy91/following{/other_user}",
    gists_url: "https://api.github.com/users/Kemmy91/gists{/gist_id}",
    starred_url: "https://api.github.com/users/Kemmy91/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/Kemmy91/subscriptions",
    organizations_url: "https://api.github.com/users/Kemmy91/orgs",
    repos_url: "https://api.github.com/users/Kemmy91/repos",
    events_url: "https://api.github.com/users/Kemmy91/events{/privacy}",
    received_events_url: "https://api.github.com/users/Kemmy91/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "alivanoy",
    id: 24864699,
    node_id: "MDQ6VXNlcjI0ODY0Njk5",
    avatar_url: "https://avatars2.githubusercontent.com/u/24864699?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/alivanoy",
    html_url: "https://github.com/alivanoy",
    followers_url: "https://api.github.com/users/alivanoy/followers",
    following_url:
      "https://api.github.com/users/alivanoy/following{/other_user}",
    gists_url: "https://api.github.com/users/alivanoy/gists{/gist_id}",
    starred_url: "https://api.github.com/users/alivanoy/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/alivanoy/subscriptions",
    organizations_url: "https://api.github.com/users/alivanoy/orgs",
    repos_url: "https://api.github.com/users/alivanoy/repos",
    events_url: "https://api.github.com/users/alivanoy/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/alivanoy/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "Turanwest",
    id: 40670951,
    node_id: "MDQ6VXNlcjQwNjcwOTUx",
    avatar_url: "https://avatars1.githubusercontent.com/u/40670951?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/Turanwest",
    html_url: "https://github.com/Turanwest",
    followers_url: "https://api.github.com/users/Turanwest/followers",
    following_url:
      "https://api.github.com/users/Turanwest/following{/other_user}",
    gists_url: "https://api.github.com/users/Turanwest/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/Turanwest/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/Turanwest/subscriptions",
    organizations_url: "https://api.github.com/users/Turanwest/orgs",
    repos_url: "https://api.github.com/users/Turanwest/repos",
    events_url: "https://api.github.com/users/Turanwest/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/Turanwest/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "cvsiraj95",
    id: 20457752,
    node_id: "MDQ6VXNlcjIwNDU3NzUy",
    avatar_url: "https://avatars2.githubusercontent.com/u/20457752?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/cvsiraj95",
    html_url: "https://github.com/cvsiraj95",
    followers_url: "https://api.github.com/users/cvsiraj95/followers",
    following_url:
      "https://api.github.com/users/cvsiraj95/following{/other_user}",
    gists_url: "https://api.github.com/users/cvsiraj95/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/cvsiraj95/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/cvsiraj95/subscriptions",
    organizations_url: "https://api.github.com/users/cvsiraj95/orgs",
    repos_url: "https://api.github.com/users/cvsiraj95/repos",
    events_url: "https://api.github.com/users/cvsiraj95/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/cvsiraj95/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "sidharthchawda",
    id: 33715740,
    node_id: "MDQ6VXNlcjMzNzE1NzQw",
    avatar_url: "https://avatars3.githubusercontent.com/u/33715740?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/sidharthchawda",
    html_url: "https://github.com/sidharthchawda",
    followers_url: "https://api.github.com/users/sidharthchawda/followers",
    following_url:
      "https://api.github.com/users/sidharthchawda/following{/other_user}",
    gists_url: "https://api.github.com/users/sidharthchawda/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/sidharthchawda/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/sidharthchawda/subscriptions",
    organizations_url: "https://api.github.com/users/sidharthchawda/orgs",
    repos_url: "https://api.github.com/users/sidharthchawda/repos",
    events_url: "https://api.github.com/users/sidharthchawda/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/sidharthchawda/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "mahmudalhakim",
    id: 16646383,
    node_id: "MDQ6VXNlcjE2NjQ2Mzgz",
    avatar_url: "https://avatars0.githubusercontent.com/u/16646383?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/mahmudalhakim",
    html_url: "https://github.com/mahmudalhakim",
    followers_url: "https://api.github.com/users/mahmudalhakim/followers",
    following_url:
      "https://api.github.com/users/mahmudalhakim/following{/other_user}",
    gists_url: "https://api.github.com/users/mahmudalhakim/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/mahmudalhakim/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/mahmudalhakim/subscriptions",
    organizations_url: "https://api.github.com/users/mahmudalhakim/orgs",
    repos_url: "https://api.github.com/users/mahmudalhakim/repos",
    events_url: "https://api.github.com/users/mahmudalhakim/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/mahmudalhakim/received_events",
    type: "User",
    site_admin: false,
  },
];
